import { render, staticRenderFns } from "./WaterSupplyWriteBody.vue?vue&type=template&id=25fd848b&scoped=true"
import script from "./WaterSupplyWriteBody.vue?vue&type=script&lang=js"
export * from "./WaterSupplyWriteBody.vue?vue&type=script&lang=js"
import style0 from "./WaterSupplyWriteBody.vue?vue&type=style&index=0&id=25fd848b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fd848b",
  null
  
)

export default component.exports